// components/GameBoard.js - Game board component
import React from 'react';
import Card from './Card';

function GameBoard({
  cards,
  flippedCards,
  handleCardClick,
  gameStarted,
  clickToContinue,
}) {
  // If no game is started yet, show empty board
  if (!gameStarted || cards.length === 0) {
    return <div className="empty-board"></div>;
  }

  return (
    <div className="game-board-container">
      <div className="game-board">
        {cards.map((card) => (
          <Card
            key={card.id}
            id={card.id}
            front={card.front}
            back={card.back}
            matched={card.matched}
            flipped={flippedCards.includes(card.id) || card.matched}
            onClick={handleCardClick}
          />
        ))}
      </div>
    </div>
  );
}

export default GameBoard;
